import { extendTheme } from "@chakra-ui/react";
import { badgeTheme } from "./components/badge";
import { buttonTheme } from "./components/button";
import { inputTheme } from "./components/input";
import { modalTheme } from "./components/modal";
import { numberInputTheme } from "./components/numberInput";
import { popoverTheme } from "./components/popover";
import { tableTheme } from "./components/table";
import { tabsTheme } from "./components/tabs";
import { textareaTheme } from "./components/textarea";
import { tooltipTheme } from "./components/tooltip";
import { breakpoints } from "./foundations/breakpoints";
import { colors } from "./foundations/colors";
import { fonts } from "./foundations/fonts";
import { shadows } from "./foundations/shadows";
import { textStyles } from "./foundations/textStyles";
import { styles } from "./styles/styles";

// Follow the structure recommended by Chakra UI
// https://github.com/chakra-ui/chakra-ui/tree/main/packages/theme/src
export const theme = extendTheme({
  breakpoints,
  colors,
  shadows,
  fonts,
  textStyles,
  components: {
    Button: buttonTheme,
    Input: inputTheme,
    Textarea: textareaTheme,
    NumberInput: numberInputTheme,
    Table: tableTheme,
    Tabs: tabsTheme,
    Popover: popoverTheme,
    Tooltip: tooltipTheme,
    Badge: badgeTheme,
    Modal: modalTheme,
  },
  styles,
});
